var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 46,
    viewBox: "0 0 184 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9146 4.18188L76.6193 46.0001H74.1221L90.4701 4.18188H92.9146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8721 5.29248H69.63V14.3796H55.7159V20.1387H68.9054V29.1969H55.7159V35.6541H69.9254V45.0198H41.8721V5.29248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9817 21.289L31.1767 8.01285C33.4488 8.10328 35.3481 8.8521 38.8301 11.0298V7.65471C36.0093 5.96896 33.2448 5.15503 30.4275 5.15503C24.6874 5.15503 20.0095 9.80712 20.0095 15.6819C20.0095 18.8653 21.033 20.9815 22.5806 22.5226L16.1792 38.8411L2.90874 5.27802H0L15.7431 45.3526H16.5661L24.8316 24.2337C29.9421 27.2904 37.2896 27.7499 37.2896 35.1078C37.2896 39.5863 33.9377 43.0193 29.6326 43.0193C26.8153 43.0193 24.5291 41.9738 20.4913 38.7724V42.379C23.6815 44.705 26.8188 45.8699 29.7944 45.8699C35.6963 45.8699 40.325 41.102 40.325 34.9921C40.325 24.7365 30.9199 24.8016 25.9888 21.289H25.9817ZM23.0378 15.5662C23.0378 12.1657 25.0989 9.42728 28.1096 8.42162L23.9171 19.1113C23.3614 18.1599 23.0378 17.0095 23.0378 15.5662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1203 0H23.7197V2.80717H37.1203V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.533 6.49351H98.8295V9.19939H102.533V10.4583H98.8295V14.9982H97.4648V5.23462H102.533V6.49351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.348 14.9982H109.955L108.689 12.1187H104.651L103.455 14.9982H102.062L106.142 5.1731H107.103L111.348 14.9982ZM108.133 10.8598L106.603 7.32188L105.182 10.8598H108.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.276 9.85777L120.415 14.9982H118.551L113.704 10.1725V14.9982H112.325V5.23462H113.704V9.70222L117.7 5.23462H119.398L115.276 9.85777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.571 10.7766C128.571 11.7208 128.571 13.081 127.499 14.0685C126.651 14.8427 125.592 15.1285 124.506 15.1285C123.169 15.1285 121.692 14.6546 120.943 13.4246C120.415 12.5673 120.415 11.435 120.415 10.7766V5.23462H121.78V10.7766C121.78 12.0644 121.892 12.5673 122.378 13.0665C122.782 13.497 123.408 13.884 124.509 13.884C126.039 13.884 126.707 13.0665 126.961 12.5962C127.14 12.2525 127.224 11.7389 127.224 10.7766V5.23462H128.575V10.7766H128.571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.762 13.7249H136.035V14.9982H130.383V5.23462H131.762V13.7249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.883 6.46457H139.57V14.9982H138.205V6.46457H134.948V5.23462H142.883V6.46457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.945 14.9982H149.552L148.286 12.1187H144.248L143.052 14.9982H141.659L145.739 5.1731H146.699L150.945 14.9982ZM147.73 10.8598L146.2 7.32188L144.779 10.8598H147.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8295 29.8915H97.4648V20.1243H98.8295V29.8915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.705 29.8915H108.534L102.186 22.3743V29.8915H100.905V20.1243H102.006L108.411 27.6993V20.1243H109.705V29.8915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 21.3831H113.046V24.089H116.75V25.3479H113.046V29.8878H111.682V20.1206H116.75V21.3795V21.3831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.917 24.9933C127.917 27.8004 125.828 30.018 122.726 30.018C119.624 30.018 117.714 27.757 117.714 25.0331C117.714 22.3091 119.55 19.9939 122.796 19.9939C126.043 19.9939 127.921 22.3706 127.921 24.9897L127.917 24.9933ZM119.117 25.0367C119.117 27.2578 120.816 28.7157 122.807 28.7157C123.823 28.7157 124.924 28.2852 125.578 27.5544C126.176 26.8816 126.525 25.8217 126.525 24.9788C126.525 23.3618 125.329 21.3143 122.849 21.3143C120.19 21.3143 119.117 23.4052 119.117 25.0367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.941 20.1243C132.388 20.1243 132.972 20.1677 133.57 20.439C134.586 20.8839 135.061 21.857 135.061 22.8446C135.061 23.9769 134.505 24.8342 133.475 25.2503C134.336 25.8363 134.867 26.7407 135.592 27.9417C135.996 28.6145 136.232 28.9437 136.886 29.8879H135.272C134.952 29.414 133.629 27.2833 133.323 26.8673C132.391 25.6373 131.931 25.6373 131.276 25.6373H130.914V29.8915H129.563V20.1243H131.945H131.941ZM130.911 21.3144V24.3929H131.438C131.646 24.3929 132.384 24.3929 132.761 24.2518C133.401 23.995 133.665 23.3764 133.665 22.8482C133.665 22.2911 133.387 21.7594 132.94 21.5459C132.592 21.3723 132.145 21.318 131.326 21.318H130.907L130.911 21.3144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.685 29.8915H145.32V22.2875L142.397 26.0678H142.148L139.197 22.2875V29.8915H137.832V20.1243H139.112L142.274 24.1324L145.422 20.1243H146.688V29.8915H146.685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.907 29.8913H155.514L154.248 27.0118H150.21L149.014 29.8913H147.621L151.701 20.0698H152.661L156.907 29.8913ZM153.692 25.7529L152.162 22.215L150.741 25.7529H153.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.617 21.3542H160.304V29.8879H158.94V21.3542H155.683V20.1243H163.617V21.3542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.205 29.8915H164.841V20.1243H166.205V29.8915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.19 24.751L176.329 29.8915H174.465L169.618 25.0658V29.8915H168.239V20.1243H169.618V24.5919L173.614 20.1243H175.312L171.19 24.751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.493 24.7221V29.8915H179.1V24.7221L175.59 20.1243H177.232L179.779 23.4885L182.353 20.1243H183.996L180.486 24.7221H180.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.696 44.7809H104.303L103.037 41.9014H98.9988L97.803 44.7809H96.4102L100.49 34.9558H101.45L105.696 44.7809ZM102.481 40.6425L100.951 37.1046L99.5299 40.6425H102.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.981 37.1626C114.172 36.3595 113.395 36.146 112.755 36.146C111.823 36.146 111.253 36.6597 111.253 37.2783C111.253 38.1103 111.809 38.4504 113.62 39.5393C114.025 39.7816 114.482 40.1253 114.844 40.6281C115.136 41.0152 115.361 41.5433 115.361 42.2451C115.361 43.779 114.288 44.9076 112.604 44.9076C111.672 44.9076 110.778 44.5784 110.043 44.0069V42.2307C110.321 42.5888 111.172 43.6632 112.604 43.6632C113.314 43.6632 114.081 43.2038 114.081 42.3754C114.081 41.547 113.272 40.9573 112.829 40.686C111.323 39.7563 110.894 39.485 110.476 38.9388C110.184 38.5517 110.001 38.0959 110.001 37.4773C110.001 36.0013 111.088 34.8835 112.801 34.8835C113.582 34.8835 114.331 35.1259 114.985 35.5709V37.1589L114.981 37.1626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.908 36.2473H120.594V44.7809H119.23V36.2473H115.973V35.0173H123.908V36.2473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.969 44.7809H130.576L129.31 41.9014H125.272L124.076 44.7809H122.684L126.764 34.9558H127.724L131.969 44.7809ZM128.754 40.6425L127.224 37.1046L125.803 40.6425H128.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.68 36.2473H135.367V44.7809H134.002V36.2473H130.745V35.0173H138.68V36.2473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.269 44.7809H139.904V35.0137H141.269V44.7809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.814 37.1626C147.005 36.3595 146.228 36.146 145.588 36.146C144.656 36.146 144.086 36.6597 144.086 37.2783C144.086 38.1103 144.642 38.4504 146.453 39.5393C146.858 39.7816 147.315 40.1253 147.677 40.6281C147.969 41.0152 148.194 41.5433 148.194 42.2451C148.194 43.779 147.121 44.9076 145.437 44.9076C144.505 44.9076 143.611 44.5784 142.876 44.0069V42.2307C143.154 42.5888 144.005 43.6632 145.437 43.6632C146.147 43.6632 146.914 43.2038 146.914 42.3754C146.914 41.547 146.105 40.9573 145.662 40.686C144.156 39.7563 143.727 39.485 143.309 38.9388C143.017 38.5517 142.834 38.0959 142.834 37.4773C142.834 36.0013 143.921 34.8835 145.634 34.8835C146.415 34.8835 147.164 35.1259 147.818 35.5709V37.1589L147.814 37.1626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.738 36.2473H153.424V44.7809H152.06V36.2473H148.803V35.0173H156.738V36.2473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.33 44.7809H157.965V35.0137H159.33V44.7809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.313 39.6404L169.452 44.7809H167.588L162.741 39.9552V44.7809H161.362V35.0137H162.741V39.4813L166.737 35.0137H168.435L164.313 39.6368V39.6404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.613 39.6115V44.7809H172.22V39.6115L168.71 35.0137H170.352L172.899 38.3779L175.474 35.0137H177.116L173.606 39.6115H173.613Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFis);
export default __webpack_public_path__ + "static/media/fis.1d2321e0f26fb52399d1109f70ffa23b.svg";
export { ForwardRef as ReactComponent };